import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { Textfield } from ".."
import { displayError } from "../../helpers";
import { ModalLayout } from "./BigModalLayout";
import { fundRaiserPageAction } from "../../store/actions";

export function MessageToDonor({ open, setOpen, donor }) {
    const dispatch = useDispatch();
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [sendingProgress, setSendingProgress] = useState(false);

    const closeModal = () => {
        setOpen(false);
    }

    const handleTextChange = (e) => {
        setErrorMessage(null);
        setMessage(e.target.value);
    }

    const handleSubmit = async () => {
        if (message) {
            setSendingProgress(true);
            const payload = {
                thankyou_message: message,
                donor_email: donor.email,
                first_name: donor.first_name,
                last_name: donor.last_name,
                user_id: donor.user_id,
                donation_id: donor.donation_id,
                fundraiser_page_id: donor.fundraiser_page_id
            };
            await dispatch(fundRaiserPageAction.sendThankyouMessage(payload));
            setMessage("");
            setSendingProgress(false);
            closeModal();
        }
        else setErrorMessage("Message is required")
    }

    return (
        <ModalLayout
            open={open}
            title="Send thankyou message to donor"
            setOpen={setOpen}
            rightButtonLabel={"Send"}
            onClickRight={handleSubmit}
            loadingRight={sendingProgress}
            disabledRight={sendingProgress}
        >
            <Textfield
                id="thankyou_message"
                name="thankyou_message"
                onChange={handleTextChange}
                label="Write message here..."
                margin="normal"
                rows={2}
                error={displayError(errorMessage)}
                helpertext={errorMessage}
                multiline
                autoFocus
                fullWidth
            />
        </ModalLayout>
    )
}